import BreakdownHOK from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/BreakdownHOK';

const FundDetailsBreakdownSectorTable = () => {
  return <BreakdownHOK endpoint="sector" titleKey="fundDetailsBreakdownSectorTitle" />;
};

export default FundDetailsBreakdownSectorTable;
